import {
  Dialog,
  DialogContent,
  BUTTON_VARIANTS,
  Checkbox,
  Button,
} from 'cdk-radial';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';

import './DealerAPIDirectoryTerms.scss';
import { acceptTerms } from '../../../redux/connectedComponent/apiDirectory/apiDirectory.slice';
import { MSA_CONSENT_STATUS } from '../../../constants/constants';

export const DealerAPIDirectoryTerms = ({showTerms,setShowTerms}) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { authenticationToken: token } = useSelector(
    (state) => state.loginDetailsSlice
  );
  const { submittingTerms, daabConsentDetails } = state?.apiDirectorySlice;
  const [checked, setChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  const [termsBlob, setTermsBlob] = useState();

  const [haveMadeTermsSelection, setHaveMadeTermsSelection] = useState(false);

  const [continueButtonIsDisabled, setContinueButtonIsDisabled] =
    useState(true);

  const [termsResponse, setTermsResponse] = useState(false);

  const handleContinue = async () => {
    await dispatch(
      acceptTerms({
        payload: {
          file: termsBlob,
          msaDocId: termsResponse.msaDocId,
        },
        token,
      })
    ).unwrap();
    setShowTerms(false)
  };

  const handleDecline = () => {
    setIsOpen(false);
    setChecked(false);
    setHaveMadeTermsSelection(true);
    setShowTerms(false)
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
    setContinueButtonIsDisabled(!event.target.checked);
  };

  const loadTerms = async () => {
    try {
      const response = await axios.get(
        `${environmentURLs.REACT_APP_DEALER_API_BUYER_SERVICE_URL}/consent?resolveConsentDocument=true`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data } = response;
      setTermsResponse(data);
    } catch (error) {
      console.error('Fetching terms not successful', error);
    }
  };

  useEffect(() => {
    loadTerms();
  }, []);

  useEffect(() => {
    if (termsResponse.consentStatus === MSA_CONSENT_STATUS.NOT_CONSENTED) {
      setTermsBlob(termsResponse.msaDocFile);
    } else if (termsResponse.consentStatus === MSA_CONSENT_STATUS.CONSENTED) {
      setHaveMadeTermsSelection(true);
    }
  }, [termsResponse]);

  useEffect(() => {
    if (
      !submittingTerms &&
      daabConsentDetails?.consentStatus === MSA_CONSENT_STATUS.CONSENTED
    ) {
      setIsOpen(false);
    }
  }, [submittingTerms]);

  const renderCustomFooter = () => (
    <div
      style={{
        padding: '16px',
      }}
    >
      <Checkbox
        dataTestId="terms-accept-checkbox"
        id="terms-accept-checkbox"
        label="I comply with the statement above."
        labelPosition="after"
        name="terms-accept-checkbox"
        onChange={handleCheckboxChange}
        size="standard"
        checked={checked}
      />

      <div class="terms-btn-container">
        <Button
          id="api-terms-dialog-decline"
          onClick={handleDecline}
          text="Decline"
          variant={BUTTON_VARIANTS.SECONDARY}
          className="api-terms-button"
        />

        <div class="terms-btn-divider"></div>

        <Button
          id="api-terms-dialog-decline"
          onClick={handleContinue}
          text="Continue"
          variant={BUTTON_VARIANTS.PRIMARY}
          isDisabled={continueButtonIsDisabled}
          className="api-terms-button"
          isLoading={submittingTerms === true}
        />
      </div>
    </div>
  );

  return (
    <Dialog
      id="api-terms-dialog"
      title={`API Purchase Compliance Addendum`}
      isOpen={(isOpen && !haveMadeTermsSelection && termsResponse) || showTerms}
      hideCloseButton={true}
      renderCustomFooterComponent={renderCustomFooter}
    >
      <DialogContent>
        <iframe
          className="app-review-terms-doc"
          title={'Terms and Conditions'}
          src={`data:application/pdf;base64,${termsBlob}`}
        />
      </DialogContent>
    </Dialog>
  );
};
